import React from 'react';
import { Container } from 'react-bootstrap';
import DashboardTab from './DashboardTab';

function DashboardPortal() {
  return (
    <Container className="mt-4 mb-5">
      <DashboardTab />
    </Container>
  );
}

export default DashboardPortal;
